export enum SourceAction {
  post = 'post',
  comment = 'comment',
  common = 'common',
}

export type WarRoomModalParams = {
  source?: SourceAction;
};
